import React, { useRef, useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Gallery = ({ images }) => {
  const mainSlider = useRef(null);
  const thumbSlider = useRef(null);

  const [nav1, setNav1] = useState(null);
  const [nav2, setNav2] = useState(null);

  useEffect(() => {
    setNav1(mainSlider.current);
    setNav2(thumbSlider.current);
  }, []);

  const mainSettings = {
    asNavFor: nav2,
    ref: mainSlider,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    autoplay: false,
    autoplaySpeed: 6000,
  };

  const thumbSettings = {
    asNavFor: nav1,
    ref: thumbSlider,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    focusOnSelect: true,
    autoplay: false,
    autoplaySpeed: 6000,
  };

  return (
    <>
      <div className="main-slider">
        <Slider {...mainSettings}>
          {images.map((product, index) => (
            <div key={index} className="product-card">
              <img src={product} alt="Car Photo" />
            </div>
          ))}
        </Slider>
      </div>
      <div className="thumb-slider">
        <Slider {...thumbSettings}>
          {images.map((product, index) => (
            <div key={index} className="product-thumb">
              <img src={product} alt="Car Photo" />
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default Gallery;
